import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import HelperText from './HelperText'

const OPTIONS = {
  options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link'],
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  container: ({height, innerHeight}) => ({
    border: '1px solid #ccc',
    padding: theme.spacing(1),
    minHeight: `${height}px`,
    maxHeight: `${height}px`,
    height: `${height}px`,
    '& .wrapper': {
      height: '100%',
    },
    '& .editor': {
      height: `${innerHeight}px`,
      paddingBottom: theme.spacing(1),
    }
  }),
}))

const Markdown = ({
  field: {
    name,
    value,
  },
  form: {
    setFieldValue,
  },
  touched,
  error,
  item,
}) => {
  const height = item.height || 200
  const classes = useStyles({
    height,
    innerHeight: item.innerHeight || (height-70),
  })

  const onContentStateChange = (contentState) => {
    setFieldValue(name, contentState)
  }

  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root }>
      <Typography variant="subtitle1">{ title }</Typography>
      <div className={ classes.container }>
        <Editor
          wrapperClassName="wrapper"
          editorClassName="editor"
          initialContentState={ value }
          onContentStateChange={ onContentStateChange }
          toolbar={ OPTIONS }
        />
      </div>
      {
        item.helperText && (
          <HelperText
            helperText={ item.helperText }
            touched={ touched }
            error={ touched && error }
          />
        )
      }
      {
        touched && error && (
          <HelperText
            helperText={ error }
            error
            touched={ touched }
          />
        )
      }
    </FormControl>
  )  
}

export default Markdown